import React, { useState, useEffect } from "react"
import _ from "lodash"

import { dataLimits } from 'utils/constants'

/**
 * 
 * @param {String} url - collcation path
 * @param {any} defaultValue 
 * @param {array} deps - If present, effect will only activate if the values in the list change
 * @param {object} query 
 * @param {string} query.field
 * @param {string} query.value
 * @param {object} groupQuery - to retrieve documents from a collection group instead of from a single collection.
 */

export default function useFetchStatus(url, defaultValue, deps, query = null, groupQuery = false, pagination) {

  let db = window.firebaseFirestore

  const [state, setState] = useState({
    value: defaultValue,
    error: null,
    isLoading: false
  })

  useEffect(() => {

    let isSubscribed = true

    if (url === '') return 
    
    setState({ ...state, isLoading: true })

    let ref

    // identify the collection | collection group
    if (groupQuery){

      ref = db.collectionGroup(groupQuery)

    } else {

      ref = db.collection(url)
    }

    // add the query
    if (query) {

      if (Array.isArray(query)) { // many query

        _.forEach(query, q => ref = ref.where(q.field, '==', q.value))

      } else {

        ref = ref.where(query.field, '==', query.value)
      }

    }

    // pagination
    if (pagination){
      let { lastVisible, orderBy } = pagination
      
      ref = ref.orderBy(orderBy, 'desc')
      
      if (lastVisible)
        ref = ref.startAfter(lastVisible)
        
      ref = ref.limit(dataLimits)
    }

    // get the data
    ref.get().then(async (querySnapshot) => {

      let value = {}

      querySnapshot.forEach(async (doc) => {
        let data = doc.data()
        let id = doc.id
        
        value[id] = {...data, id}
        
      })
      
      return isSubscribed
        ? setState({
          value,
          error: null,
          isLoading: false,
        })
        : null
    })
      .catch((error) => {
        console.error(error)

        return isSubscribed
          ? setState({
            value: defaultValue,
            error: error,
            isLoading: false,
          })
          : null
      })

    return () => (isSubscribed = false)

  }, deps)

  const { value, error, isLoading } = state
  return [value, error, isLoading]
}